import axios from "axios";
import { API } from "./client";

// Listing
export const getEvaluations  = () => axios.get(`${API}/evaluations`);
export const getComparisons  = () => axios.get(`${API}/comparisons`);
export const getAnalyses     = () => axios.get(`${API}/analyses`);

// Re-evaluate
export const reEvaluate          = (id)     => axios.post(`${API}/evaluations/${id}/re-evaluate`);
export const getReEvaluateStatus = (taskId) => axios.get(`${API}/task-status/${taskId}`);

// Delete by type
const DELETE_ENDPOINTS = {
  evaluation: (id) => `${API}/evaluations/${id}`,
  comparison: (id) => `${API}/comparisons/${id}`,
  analysis:   (id) => `${API}/analysis/${id}`,
};
export const deleteHistoryItem = (type, id) => axios.delete(DELETE_ENDPOINTS[type](id));

// Rename by type
const RENAME_ENDPOINTS = {
  evaluation: (id) => `${API}/evaluations/${id}/name`,
  comparison: (id) => `${API}/comparisons/${id}/name`,
  analysis:   (id) => `${API}/analysis/${id}/name`,
};
export const renameHistoryItem = (type, id, name) =>
  axios.patch(RENAME_ENDPOINTS[type](id), { name });

// Research cache
export const getResearchCache         = ()   => axios.get(`${API}/research-cache`);
export const deleteResearchCacheEntry = (id) => axios.delete(`${API}/research-cache/${id}`);

// Report downloads for history panel
const DOWNLOAD_URLS = {
  pdf:       (id) => `${API}/download-report/${id}`,
  annotated: (id) => `${API}/download-report/${id}/annotated`,
  csv:       (id) => `${API}/download-report/${id}/csv`,
};
export const downloadHistoryReport = (type, id) =>
  axios.get(DOWNLOAD_URLS[type](id), { responseType: "blob" });
